import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Input, Cascader, Button, Modal, Radio, DatePicker, Select, Form,InputNumber} from 'antd';
import BaseComponent from "../../../base/BaseComponent";
import {HEADER_HEIGHT} from "../../../constants";
import PageTableComponent from "../../../view/resource/components/pageTable/PageTable";
import $ from "jquery";
import {formatDate} from "../../../utils";
import moment from "moment";
import {message} from "../../../view/resource/components/Mess";
const {RangePicker} = DatePicker;
const { Option } = Select;


export default class PointsManagement extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            page: 1,
            size: 10,
            inputData :{ //输入
                deptId: [],//用户部门
                nickName: '',//用户昵称
                account: '',//用户手机号
            },
            queryData:{//查询
                deptId: [],//用户部门
                nickName: '',//用户昵称
                account: '',//用户手机号
            },
            dataSource: [],
            count: 0,
            treeData: [],
            treeDataIndex: {
                key: "id",
                value: "id",
                label: "name",
                children: "child",
            },
            visible: false,//积分扣除的弹框
            cleanUpVisible: false,//一键清除
            pointsDetailsVisible: false,//积分明细
            //一键清除
            integral:{
                integralType:'clean',//积分状态
                integralRemark:''
            },
            //批量扣除积分
            deductPoint: {
                integral:null,
                remark: ''
            },
            details: {
                type: undefined,
                startTime: '',
                endTime: '',
                userId: '',
                start: 1,
                size: 10
            }, //积分明细里面的参数
            detailsCount: 0,//积分里面的总个数
            data: [],//积分明细的数据
            integralType: [],//积分类型
            selectedRowKeys: [],


        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        let integralType = JSON.parse(window.sysConfig.getValueByKey('integralType', ''));
        let data = Object.entries(integralType).map(([key, value]) => ({
            key, value
        }));
        this.setState({integralType: data}, () => {
        });
        this.getData();
        this.getDeptTree()
    }

    render() {
        let height = document.body.clientHeight - HEADER_HEIGHT - 32;
        return (
            <div style={{
                background: '#ffffff',
                padding: '0 15px 16px 15px',
                margin: "15px 0 15px 15px",

                position: 'relative',
                borderRadius: 5
            }}>
                {/*渲染头部 搜索 重置 导出 等等按钮*/}
                {this.renderHeader()}
                {/*列表*/}
                {this.renderList()}
                {/*扣除积分弹框*/}
                {this.renderPointDeduct()}
                {/*一键清除*/}
                {this.renderCleanUp()}
                {/*积分明细*/}
                {this.renderPointsDetails()}
            </div>
        )

    }

    renderHeader = () => {
        return (
            <div>
                <div style={{paddingTop: 20}}>
                    <Input
                        placeholder="请输入用户昵称"
                        style={{width: 224}}
                        value={this.state.inputData.nickName}
                        onChange={(e) => {
                            this.onChange('nickName', e.target.value)
                        }}
                    />
                    <Input
                        placeholder="请输入手机号"
                        value={this.state.inputData.account}
                        style={{width: 224, marginLeft: 20}}
                        onChange={(e) => {
                            this.onChange('account', e.target.value)
                        }}
                    />
                    <Cascader options={this.state.treeData}
                              value={this.state.inputData.deptId}
                              changeOnSelect
                              onChange={(e) => {
                                  this.onChange('deptId', e)
                              }}
                              allowClear={false}
                              placeholder="请选择所属单位"
                              style={{width: 280, marginLeft: 20}}/>
                    <Button type="primary" style={{marginLeft: 20}} onClick={()=>{
                       this.query()
                    }}>查询</Button>
                    <Button type="primary" style={{marginLeft: 20}} onClick={()=>{
                        this.reset()
                    }}>重置</Button>
                </div>
                <div style={{marginTop: 20}}>
                    <Button type="primary" onClick={()=>{this.export()}}>导出</Button>
                    <Button type="primary" style={{marginLeft: 20}} onClick={()=>{
                        this.state.visible = true;
                        this.state.deductPoint.integral = null;
                        this.state.deductPoint.remark = '';
                       this.state.details.userId = '';
                        this.setState({})
                        }}>批量积分扣除</Button>
                    <Button type="primary" style={{marginLeft: 20}} onClick={()=>{
                        this.state.integral.integralRemark = '';
                        this.state.integral.integralType = 'clean';
                        this.state.cleanUpVisible = true;
                        this.setState({})
                    }}>一键清除</Button>
                </div>
            </div>
        )
    };

    renderList = () => {
        let columns = [
            {
                title: '昵称',
                key: 'nickName',
                dataIndex: 'nickName',

                ellipsis: true,

            }, {
                title: '手机号',
                key: 'account',
                dataIndex: 'account',

                ellipsis: true,

            }, {
                title: '所属单位',
                key: 'deptNames',
                dataIndex: 'deptNames',
                ellipsis: true,
                width: 350,
                render: (text, record) => {
                    return <div style={{
                        width: '100%',
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                        whiteSpace: 'nowrap'
                    }}>{text ? text.join('/') : ''}</div>

                }
            }, {
                title: '历史积分',
                key: 'integralHistoryCount',
                width: 100,
                dataIndex: 'integralHistoryCount',
                sorter: (a, b) => a.integralHistoryCount - b.integralHistoryCount,
                ellipsis: true,
            }, {
                title: '现有积分',
                key: 'integralCount',
                width: 100,
                dataIndex: 'integralCount',
                sorter: (a, b) => a.integralCount - b.integralCount,
                ellipsis: true,
            }, {
                title: '操作',
                dataIndex: 'address',
                render: (text, record) => {
                    return (<div style={{color: '#0050B3', cursor: "pointer"}}>
                        <span onClick={() => {
                            this.state.details.userId = record.userId;
                            this.state.visible = true;
                            this.state.selectedRowKeys = [];
                            this.state.deductPoint.integral = null;
                            this.state.deductPoint.remark = '';
                           this.setState({})
                        }}>积分扣除</span>
                        <span style={{marginLeft: '20px',}} onClick={() => {
                            this.state.pointsDetailsVisible = true;
                            this.state.details.userId = record.userId;
                            this.state.details.start = 1;
                            this.state.details.startTime = '';
                            this.state.details.endTime = '';
                            this.state.details.type = '';
                            this.state.details.size = 10;
                            this.setState({}, () => {
                                this.pointsDetails()
                            })
                        }}>积分明细</span>
                    </div>)
                }

            }];
        const {selectedRowKeys} = this.state;
        const rowSelection = {
            selectedRowKeys,
            onChange: (selectedRowKeys) => {
                this.state.selectedRowKeys = selectedRowKeys;
                this.setState({})
            },
        };
        return (
            <PageTableComponent
                positionHeight={50}
                columns={columns}
                rowKey = {'userId'}
                rowSelection={rowSelection}
                data={this.state.dataSource}
                page={this.state.page}
                size={this.state.size}
                count={this.state.count}
                onChangePage={(page, size) => {
                    this.onChangePage(page, size)
                }}
            ></PageTableComponent>

        )
    };

    renderPointDeduct = () =>{
        return(
            <Modal
                title="积分扣除"
                visible={this.state.visible}
                width={450}
                centered
                maskClosable={false}
                onOk={()=>{
                    this.deduct()
                }}
                onCancel={()=>{
                   this.setState({visible:false})
                }}
            >

                <div className={'pointDeduct'}>
                    <Form.Item label={"扣分值"} required style={{display:"flex"}} >
                        <InputNumber  placeholder="请输入扣除积分值"  min={0} precision={0} value={this.state.deductPoint.integral}  style={{width:300}} onChange={(value)=>{
                            this.state.deductPoint.integral = value;
                            this.setState({})
                        }} />
                    </Form.Item>
                    <Form.Item label={"备注"} required style={{display:"flex"}} >
                        <Input.TextArea  placeholder="请输入备注"  rows={4}   style={{width:300}} value={this.state.deductPoint.remark} onChange={(e)=>{
                            this.state.deductPoint.remark = e.target.value;
                            this.setState({})
                        }} />
                    </Form.Item>
                    <style>{`
                                .pointDeduct .ant-form-item-label{
                                    width: 87px;
                                    vertical-align: top
                                }
                               
                          `}</style>
                </div>

            </Modal>
        )
    };

    renderCleanUp = () => {
        return (
            <Modal
                title="提醒"
                visible={this.state.cleanUpVisible}
                width={500}
                centered
                maskClosable={false}
                onOk={() => {
                    this.allCleanUp()
                }}
                onCancel={() => {
                    this.setState({cleanUpVisible:false})
                }}
            >
                <div className={'pointDeduct'}>
                    <Form.Item label={"清除方式"} required style={{display: "flex"}}>
                        <Radio.Group onChange={(e)=>{
                             this.state.integral.integralType = e.target.value;
                             this.setState({})
                        }} value={this.state.integral.integralType}>
                            <Radio value={'clean'}>现有积分</Radio>
                            <Radio value={'cleanHistory'}>所有积分</Radio>
                        </Radio.Group>
                    </Form.Item>
                    <Form.Item label={"备注"} required style={{display: "flex"}} >
                        <Input.TextArea placeholder="请输入备注" rows={4} style={{width: 350}} value={this.state.integral.integralRemark} onChange={(e)=>{
                            this.state.integral.integralRemark = e.target.value;
                            this.setState({})
                        }}/>
                    </Form.Item>
                    <style>{`
                        .pointDeduct .ant-form-item-label{
                            width: 87px;
                            vertical-align: top
                        }
                               
              `}</style></div>

            </Modal>
        )
    };

    renderPointsDetails = () =>{
        let {integralType} = this.state;
        let columns = [
            {
                title: '变动时间',
                dataIndex: "dbUpdateTime",

                render:(dbUpdateTime)=><div >{formatDate(dbUpdateTime)}</div>

            }, {
                title: '积分变动原因',
                key: 'changeReason',
                dataIndex: 'changeReason',
                ellipsis: true,

            }, {
                title: '积分',
                key: 'integral',
                dataIndex: 'integral',
                ellipsis: true,
            }, {
                title: '备注',
                key: 'remark',
                dataIndex: 'remark',
                ellipsis: true,
            },];

        return (<Modal
            title="个人积分明细"
            visible={this.state.pointsDetailsVisible}
            width={800}
            bodyStyle={{maxHeight: "800px"}}
            centered
            maskClosable={false}
            footer={null}
            onOk={()=>{
                this.setState({pointsDetailsVisible:false})
            }}
            onCancel={()=>{
                this.setState({pointsDetailsVisible:false})
            }}
        >
            <div>
                <div>
                    <RangePicker
                        format="YYYY-MM-DD"
                        allowClear
                        value={[this.state.details.startTime ? moment(this.state.details.startTime) : undefined,
                            this.state.details.endTime ? moment(this.state.details.endTime) : undefined]}
                        onChange={(data) => {
                            this.state.details.startTime = data[0] ?  data[0]._d.setHours(0, 0, 0, 0): '';
                            this.state.details.endTime = data[1] ?data[1]._d.setHours(23, 59, 59): '';
                            this.setState({}, () => {
                                this.state.details.start = 1;
                                this.pointsDetails()
                            })
                        }}
                        placeholder={['开始时间', '结束时间']}
                    />
                    <Select value={this.state.details.type!==''?this.state.details.type:undefined}
                            allowClear
                            placeholder={'请选择积分变动原因'}
                            style={{width: 200, marginLeft: 20}}
                            onChange={(value) => {
                                if (value !== undefined) {
                                    this.state.details.type = value;
                                } else {
                                    this.state.details.type = '';
                                }
                                this.setState({}, () => {
                                    this.pointsDetails()
                                })
                            }}
                    >
                        {integralType && integralType.length && integralType.map((item, index) => {
                            return <Option value={item.key} key={item.key}>{item.value}</Option>
                        })}
                    </Select>
                </div>
                <PageTableComponent
                    positionHeight={41}
                    columns={columns}
                    rowSelection={false}
                    data={this.state.data}
                    page={this.state.details.start}
                    size={this.state.details.size}
                    count={this.state.detailsCount}
                    onChangePage={(page, size) => {
                        this.state.details.start = page;
                        this.state.details.size = size;
                        this.setState({}, () => {
                            this.pointsDetails()
                        })
                    }}
                >
                </PageTableComponent>
            </div>

        </Modal>)
    }

    //翻页
    onChangePage(page, size) {
        this.setState({page: page, size: size}, () => {
            this.getData()
        })
    }

    //获取数据
    getData = () => {
        let parms = {
            start: this.state.page,
            size: this.state.size,
            deptId: this.state.queryData.deptId.slice(-1).toString(),
            nickName: this.state.queryData.nickName,
            account: this.state.queryData.account
        };

        this.request({
            url: '/cm-sites-mmp/integral/listTj',
            method: "get",
            body: parms,
            contentType: "json",
            callBack: (res) => {
                let dataSource = [];
                let count = 0;
                if (res && res.data && res.data.length) {
                    dataSource = res.data;
                    count = res.count;

                }
                this.setState({dataSource, count}, () => {
                    $('.ant-pagination-options-quick-jumper').find('input').val('')
                })
            }
        });
    };

    onChange = (name, value) => {
        this.state.inputData[name] = value;
        this.setState({},()=>{
           console.log(this.state.inputData)
        })
    };

    //获取全部单位
    getDeptTree = () =>{
        this.request({
            url: "/cm-sites-sys/dept/getTree",
            body: {id: 0},
            callBack: (res) => {
                let data = [res];
               const treeData = this.getTreeData(data, this.state.treeDataIndex);
                this.setState({
                    treeData:treeData
                });
            }
        });
    };

    getTreeData =(treeData, treeDataIndex)=> {
        const newTreeData = [];
        for (let i = 0; i < treeData.length; i++) {
            const treeNode = treeData[i];
            let item = {
                value: treeNode[treeDataIndex["value"]],
                label: treeNode[treeDataIndex["label"]],
                key: treeNode[treeDataIndex["key"]],
                data: treeNode
            };
            treeNode[treeDataIndex["children"]] && treeNode[treeDataIndex["children"]].length > 0 && (item.children = this.getTreeData(treeNode[treeDataIndex["children"]], treeDataIndex));
            newTreeData.push(item);
        }
        return newTreeData;
    };

    //查询
    query = ()=>{
        this.state.page = 1;
        this.state.queryData = this.state.inputData;
        this.setState({},()=>{
            this.getData()
        })
    };

    //重置
    reset = () =>{
        this.state.queryData.deptId = [];
        this.state.queryData.nickName = '';
        this.state.queryData.account = '';
        this.state.page =1;
        this.state.selectedRowKeys = [];
        this.state.inputData = this.state.queryData;
        this.setState(()=>{
            this.getData()
        })
    };

   //导出
    export = ()=>{
        let params = {
            account:this.state.queryData.account,
            nickName:this.state.queryData.nickName,
            deptId:this.state.queryData.deptId.slice(-1).toString(),
            userIds:this.state.selectedRowKeys.join(',')
        };
        this.request({
            url: "/cm-sites-mmp/integral/integralLogExport",
            method: 'downloadGet',
            body: params,
            callBack: (res) => {
               this.setState({selectedRowKeys:[]})
            }
        })
    };

   // 积分明细
    pointsDetails = () =>{

        this.request({
            url: '/cm-sites-mmp/integral/list',
            method: "get",
            body: this.state.details,
            contentType: "json",
            callBack: (res) => {
                let data = [];
                let detailsCount = 0;
                if (res && res.data && res.data.length) {
                    data = res.data;
                    detailsCount = res.count;
                }
                this.setState({detailsCount, data}, () => {
                    $('.ant-pagination-options-quick-jumper').find('input').val('')
                })
            }
        });
    };

    //一键清除
    allCleanUp = () =>{
        console.log(this.state.integral.integralRemark)
        if($.trim(this.state.integral.integralRemark) === ''){
            message.destroy();
            message.warning("请填写备注");
            return false
        }
        let params = {
            account:this.state.queryData.account,
            nickName:this.state.queryData.nickName,
            deptId:this.state.queryData.deptId.slice(-1).toString(),
            userIds:this.state.selectedRowKeys.join(','),
            type:this.state.integral.integralType,
            remark:this.state.integral.integralRemark
        };
        this.request({
            url: "/cm-sites-mmp/integral/saveCleanIntegralLog",
            method: 'post',
            body: params,
            contentType: "json",
            callBack: (res) => {
              if(res){
                  message.destroy();
                  message.success('清除成功');
                  this.state.cleanUpVisible = false;
                  this.state.selectedRowKeys = [];
                  this.state.page = 1;
                  this.setState({},()=>{
                      this.getData()
                  });
              }
            }
        })
    };

    //积分扣除
    deduct = () =>{
        if(this.state.deductPoint.integral <1){
            message.destroy();
            message.warning("请输入扣除的积分值");
            return false
        }
        if($.trim(this.state.deductPoint.remark) === ''){
            message.destroy();
            message.warning("请填写备注");
            return false
        }
        let params = {
            account:this.state.queryData.account,
            nickName:this.state.queryData.nickName,
            deptId:this.state.queryData.deptId.slice(-1).toString(),
            userIds:this.state.details.userId?this.state.details.userId:this.state.selectedRowKeys.join(','),
            integral:this.state.deductPoint.integral,
            remark:this.state.deductPoint.remark
        };
        this.request({
            url: "/cm-sites-mmp/integral/saveDelIntegralLog",
            method: 'post',
            body: params,
            contentType: "json",
            callBack: (res) => {
                if (res === true) {
                    message.destroy();
                    message.success('扣除成功');
                    this.state.visible = false;
                    this.state.selectedRowKeys =[];
                    this.state.details.userId = '';
                    this.setState({},()=>{
                        this.getData()
                    });
                } else {
                    message.destroy();
                    message.warning(res);
                }
            }
        })
    };


}

